import React from 'react'
import {Container,Row,Col} from 'react-bootstrap'
const componentLogo = () => {
  return (
    <>
      <Container fluid="100%" id="inicio">
        <Row>
          <Col>
            <div className="portadaPrincipal">
              <div className="logoPrincipal2">
                <img alt="logoGrande" className="logoGrande" src="./img/milaLogo_navidad.png"/>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default componentLogo